import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Note from '@shared/ui/messages/Note';
import { StartVerificationBtn } from '@widgets/buttons';
// import NeedMoreLimits from '@widgets/dashboard/NeedMoreLimits';
import PrivateBins from '@widgets/dashboard/PrivateBins';

export default function DashboardUnverified() {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.user);

  return (
    <section className="dashboardUnverif main-section">
      <div className="dashboardUnverif__content block-pd-y">
        <div className="block-pd-x dashboardUnverif__top">
          <img
            className="dashboardUnverif__img"
            src="/images/emoji-hand.png"
            alt=""
          />
          <p className="main-title t-center">
            {t('hello_name', { name: user.name })}
          </p>
          <Note
            type={user.is_onboarding ? 'info' : 'warning'}
            title={t('verification')}
            content={t(
              user.is_onboarding
                ? 'verification_pending_content'
                : 'verification_start_content',
            )}
          >
            <StartVerificationBtn />
          </Note>
        </div>
        <div className="offer block-pd-x">
          <PrivateBins />
        </div>
      </div>
      {/* <div className="block-pd-y block-pd-x">
        <h1 className="title-h2m">{t('Dashboard')}</h1>
      </div>
      <div className="block-pd-x">
        <div className="dashboard__container">
          <Note
            type={user.is_onboarding ? 'info' : 'warning'}
            title={t('verification')}
            content={t(
              user.is_onboarding
                ? 'verification_pending_content'
                : 'verification_start_content',
            )}
          >
            <StartVerificationBtn />
          </Note>
        </div>
      </div>
      <div className="block-pd-x block-pd-y offer">
        <div className="dashboard__container"> */}
      {/* <NeedMoreLimits /> */}
      {/* <PrivateBins />
        </div>
      </div> */}
    </section>
  );
}
